import { styled } from '@mui/material/styles';
import {
    Typography,
    Card,
} from '@mui/material';

export const settings = {
    width: 100,
    height: 92.4,
    value: 60,
};

export const RefreshIconPage = styled('img')({
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
        transform: 'rotate(360deg)',
    },
});

export const HeaderTitle = styled(Typography)({
    flexGrow: 1,
    fontSize: '1.4rem',
    color: '#333',
    fontWeight: 'normal',
    textAlign: 'left',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
    marginLeft: '10px',
});

export const ContentContainer = styled('div')({
    position: 'relative',
    minHeight: 'calc(100vh - 64px)',
    paddingBottom: '100px',
    overflowY: 'auto',
    marginLeft: 70
});

export const MainContent = styled('div')({
    padding: '20px',
    marginTop: '80px',
    marginBottom: '10px',
    position: 'relative',
});

export const CenteredCard = styled(Card)({
    maxWidth: '100%',
    margin: '20px',
    marginTop: '80px',
    borderBottom: '2px solid dodgerblue',
    borderRight: '2px solid dodgerblue',
    marginBottom: '50px'
});

export const mapContainerStyle = {
    width: '100%',
    height: '400px',
};

export const center = {
    lat: -3.745,
    lng: -38.523,
};
